import React, { forwardRef, memo } from "react";
import accessibleGoldenDropdown from "../AccessibleGoldenDropdown";
import FilledButton from "../../SelectButton/FilledButton";
import EmptyButton from "../../SelectButton/EmptyButton";
import { aquisitionValue } from "../../../utils/constants";

const DropdownWithOptions = forwardRef(
  (
    {
      OPTIONS,
      optionRefs,
      isOpen,

      showArrow,
      focusedIndex,
      selected,
      selectedIndex,
      headingValue,
      setHeadingValue,
      position,

      handleOptionKeyDown,
      selectOption,
      restrictHover,
      accessibilityValues,

      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
        popupMenuClass: "",
      },
      emailReport = () => {},
      exportAllExcel = () => {},
    },
    // ref,
  ) => {
    return (
      <div
        role={accessibilityValues.ariaHaspopup}
        id={accessibilityValues.ariaControls}
        aria-label={accessibilityValues.ariaLabel}
        className={`popup_menu ${popupClassName.popupMenuClass || ""}  ${
          showArrow === false ? "no_arrow" : ""
        } ${isOpen ? "popup_menu_open" : "popup_menu_close"}`}
        style={{ ...position }}
      >
        <div className="portfolio_report_accounts_container">
          {OPTIONS.map((dateSelection, index) => {
            const isSelected = selectedIndex === index;

            const value = aquisitionValue[dateSelection];

            return (
              <div
                key={value}
                ref={(el) => (optionRefs.current[index] = el)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={focusedIndex === index ? 0 : -1}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setHeadingValue(dateSelection);
                  }
                  handleOptionKeyDown(e, index);
                }}
                onClick={() => {
                  setHeadingValue(dateSelection);
                  selectOption(index);
                }}
                className="account_listitem cursor"
              >
                <div className="radio_btn_input">
                  {headingValue.value === "" ? (
                    <EmptyButton />
                  ) : dateSelection === headingValue.value ? (
                    <FilledButton />
                  ) : (
                    <EmptyButton />
                  )}
                </div>
                <label className="radio_btn_label cursor" for={value}>
                  {value}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default memo(accessibleGoldenDropdown(DropdownWithOptions));
